// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import connect from "share/enhancers/Izenda.Connect";
import React, { Component, PropTypes } from "react";
import { observe } from "mobx";
import constants from "logic/data/Izenda.ReportDesignerConstants";
import DataSourceGridSimple from "./Izenda.DataSourceGridSimple";
import DataSourceGridAdvanced from "./Izenda.DataSourceGridAdvanced";
import ReportNameEditor from "modules/ReportDesigner/Izenda.ReportNameEditor";
import ScrollBox from "share/components/controls/Izenda.ScrollBox";
import RightContentFieldDetail from "modules/ReportDesigner/Fields/Izenda.RightContentFieldDetail";
import { get } from "lodash/fp";

@connect()
export default class DataSourceDetail extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    const { loader, fieldStore } = props;

    // Show progress bar for any promises that are not finished when navigate from Field to DataSource
    const isLoading = get("isLoading", fieldStore);
    isLoading && loader.startLoading();
    this.disposeLoader = observe(fieldStore, "isLoading", (newValue: boolean): void => {
      newValue ? loader.startLoading() : loader.endLoading();
    });
  }

  componentDidMount() {
    const { store } = this.props;
    store.dataSourceDetail.resetAliasLevel();
    return store.loadDataSourceDetail();
  }

  componentWillUnmount() {
    const { loader, fieldStore } = this.props;
    fieldStore.isLoading && loader.endLoading();
    this.disposeLoader();
  }

  renderDataSourceGrid() {
    const { store, width, fieldStore } = this.props;
    const DataSourceGrid =
      store.model.reportMode === constants.ADVANCED ? DataSourceGridAdvanced : DataSourceGridSimple;

    return <DataSourceGrid store={store} width={width} fieldStore={fieldStore} />;
  }

  render() {
    const { store, fieldStore, uiStore } = this.props;
    const { reportStore } = store;

    return (
      <div className="izenda-Wrapper-content">
        <div className="izenda-TableLayout">
          <div className="izenda-TableLayout-Cell">
            <ScrollBox>
              <div className="u_fullHeight u_paddingLeftRight">
                <ReportNameEditor store={reportStore} name={reportStore.model.reportName} showTooltip isPreviewRecord />
                {this.renderDataSourceGrid()}
              </div>
            </ScrollBox>
          </div>
          <RightContentFieldDetail
            fieldStore={fieldStore}
            reportDesignerModel={fieldStore.masterModel}
            uiStore={uiStore}
            dataSourceMode
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSource/Izenda.DataSourceDetail.js